import { useEffect, useState } from 'react';
import { PortfolioApi } from '../api/adminApi';
import {
  findFallbackBySlug,
  normalizeSlug,
  shapePortfolio
} from './portfolioHelpers';
import { getCachedPortfolioBySlug } from './usePortfolios';

export const usePortfolioDetails = (slug) => {
  const normalizedSlug = normalizeSlug(slug);
  const [portfolio, setPortfolio] = useState(() => {
    if (!normalizedSlug) return null;
    return getCachedPortfolioBySlug(normalizedSlug);
  });
  const [isLoading, setIsLoading] = useState(!portfolio);
  const [error, setError] = useState('');
  const [isFallback, setIsFallback] = useState(false);

  useEffect(() => {
    if (!normalizedSlug) {
      setPortfolio(null);
      setIsLoading(false);
      setError('Missing project identifier.');
      return;
    }

    let isMounted = true;
    setError('');
    setIsLoading(!getCachedPortfolioBySlug(normalizedSlug));

    PortfolioApi.getBySlug(normalizedSlug)
      .then((data) => {
        if (!isMounted) return;
        setPortfolio(shapePortfolio(data));
        setIsFallback(false);
      })
      .catch((apiError) => {
        if (!isMounted) return;
        const fallback = findFallbackBySlug(normalizedSlug);
        if (fallback) {
          setPortfolio(fallback);
          setIsFallback(true);
          setError('Showing fallback content.');
        } else {
          setPortfolio(null);
          setError(apiError?.response?.data?.message || apiError.message || 'Project not found.');
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [normalizedSlug]);

  return { portfolio, isLoading, error, isFallback };
};
